'use strict';

/**
 *
 * @name: ddRatings
 *
 */

import DirectiveTemplate from './nn-dropdown-ratings.directive.html';

function DdRatingsDirective($rootScope) {

  'ngInject';

  return {
    replace: true,
    template: DirectiveTemplate,
    scope: {
      post: '=',
      showRatings: '=',
      toggleDd: '='
    },
    link: function(scope, element) {

      scope.entity = scope.post;

      var changeAverageWatcher = $rootScope.$on('changeAverage', function() {

        scope.averageRating = Math.round(10 * scope.entity['rating_' + $rootScope.lang2] / scope.entity['lovesCount_' + $rootScope.lang2]) / 10;

        setTimeout(function() {

          $rootScope.$apply();
        });
      });

      if (scope.entity['lovesCount_' + $rootScope.lang2]) {

        scope.averageRating = Math.round(10 * scope.entity['rating_' + $rootScope.lang2] / scope.entity['lovesCount_' + $rootScope.lang2]) / 10;
      } else {

        scope.averageRating = 0;
      }

      scope.$watch('entity["lovesCount_' + $rootScope.lang2 + '"]', function(newVal) {

        if (newVal) {

          scope.averageRating = Math.round(10 * scope.entity['rating_' + $rootScope.lang2] / scope.entity['lovesCount_' + $rootScope.lang2]) / 10;
        }
      });

      var ratingsGoCompile = $rootScope.$on('goCompile', function() {

        setTimeout(function() {

          scope.$apply(function() {

            scope.entity = scope.post;

            if (scope.entity['lovesCount_' + $rootScope.lang2]) {

              scope.averageRating = Math.round(10 * scope.entity['rating_' + $rootScope.lang2] / scope.entity['lovesCount_' + $rootScope.lang2]) / 10;
            } else {

              scope.averageRating = 0;
            }
          });
        }, 1);
      });

      var watchShowRatings = scope.$watch('showRatings', function(newVal) {

        if (newVal === true) {

          $(element).slideDown(250);
        } else {

          $(element).slideUp(250);
        }
      });

      scope.$on('destroy', function() {

        ratingsGoCompile();
        watchShowRatings();
        changeAverageWatcher();
        element.find('*').remove();
      });
    }
  };
}

export default DdRatingsDirective;



// WEBPACK FOOTER //
// ./app/components/nn-players/nn-dropdown-ratings/nn-dropdown-ratings.directive.js